import Select from 'domains/core/components/Select';
import { NoResponseAction } from 'pages/ContentVoiceBuilderPage/types';
import { setRepeat } from 'pages/ContentVoiceBuilderPage/voiceCallActions';

type Props = {
    dispatchVoiceContentAction: React.Dispatch<any>;
    isContentLoading: boolean;
    noResponseAction: NoResponseAction;
    setNoResponseAction: (action: NoResponseAction) => void;
};

const NoResponseActionSelect = ({
    dispatchVoiceContentAction,
    isContentLoading,
    noResponseAction,
    setNoResponseAction,
}: Props) => (
    <Select
        disabled={isContentLoading}
        label="Choose Action"
        onChange={(e: any) => {
            setNoResponseAction(e.target.value);
            if (e.target.value === NoResponseAction.HANG_UP) {
                dispatchVoiceContentAction(setRepeat(0));
            }
            if (e.target.value === NoResponseAction.REPEAT) {
                dispatchVoiceContentAction(setRepeat(2));
            }
        }}
        sx={{ width: '200px' }}
        type="string"
        value={noResponseAction}
        values={[
            { label: 'Hang Up', value: NoResponseAction.HANG_UP },
            { label: 'Repeat Message', value: NoResponseAction.REPEAT },
        ]}
    />
);

export default NoResponseActionSelect;
